import { Component, OnInit } from '@angular/core';
import { SubSink } from 'subsink';
import { AutoUnsubscribe } from '../../../core/auto-unsubscribe';
import { RequestTypeEnum } from '../../../shared/xatena-api/request-type';
import { RequestTypeBaseComponent } from '../request-type-base/request-type-base.component';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FormlyModule } from '@ngx-formly/core';
import { AsyncPipe } from '@angular/common';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';

@AutoUnsubscribe()
@Component({
  selector: 'app-request-type-non-catalog-product-budgeted',
  templateUrl: './request-type-non-catalog-product-budgeted.component.html',
  styleUrls: ['./request-type-non-catalog-product-budgeted.component.scss'],
  imports: [FormlyModule, AsyncPipe, MatDatepickerModule, MatNativeDateModule],
})
export class RequestTypeNonCatalogProductBudgetedComponent
  extends RequestTypeBaseComponent
  implements OnInit
{
  subs = new SubSink();

  ngOnInit(): void {
    this.fields = [
      {
        hooks: {
          onInit: field => {
            this.subs.sink = this.isReadOnly$.subscribe(s => {
              if (s) {
                this.form.disable();
              } else {
                this.form.enable();
              }
            });
          },
        },
        hideExpression: model =>
          !(model.requestTypeId === RequestTypeEnum.NonCatalogProductBudgeted),
        fieldGroup: [
          {
            wrappers: ['mat-card'],
            templateOptions: {
              label: _('DEMAND_REQUEST.DETAIL.FORM.REQUEST_TYPE_2_GRP_1.LABEL'),
              translate: true,
            },
            fieldGroup: [
              {
                key: 'product',
                type: 'textarea',
                templateOptions: {
                  required: true,
                  appearance: this.formFieldAppearance,
                  label: _('DEMAND_REQUEST.DETAIL.FORM.PRODUCT.LABEL'),
                  description: _(
                    'DEMAND_REQUEST.DETAIL.FORM.PRODUCT.DESCRIPTION'
                  ),
                  translate: true,
                  autosize: true,
                  autosizeMinRows: 3,
                  autosizeMaxRows: 7,
                },
              },
              {
                key: 'location',
                type: 'input',
                templateOptions: {
                  required: false,
                  appearance: this.formFieldAppearance,
                  label: _('DEMAND_REQUEST.DETAIL.FORM.LOCATION.LABEL'),
                  translate: true,
                },
              },
              {
                key: 'costTotal',
                type: 'currency',
                templateOptions: {
                  required: true,
                  appearance: this.formFieldAppearance,
                  label: _('DEMAND_REQUEST.DETAIL.FORM.COST_TOTAL.LABEL'),
                  translate: true,
                  currency: this.currency$,
                },
              },
              {
                key: 'requiredDate',
                type: 'datepicker',
                templateOptions: {
                  required: false,
                  appearance: this.formFieldAppearance,
                  label: _('DEMAND_REQUEST.DETAIL.FORM.REQUIRED_DATE.LABEL'),
                  translate: true,
                },
              },
              {
                key: 'budgetPositionNumber',
                type: 'input',
                templateOptions: {
                  required: true,
                  appearance: this.formFieldAppearance,
                  label: _(
                    'DEMAND_REQUEST.DETAIL.FORM.BUDGET_POSITION_NUMBER.LABEL'
                  ),
                  translate: true,
                },
              },
            ],
          },
        ],
      },
    ];
  }
}
